import React, { useEffect, useState } from "react";

export const useSubjectsCheckbox = (
  subjects?: string[],
  defaultChecked?: boolean,
) => {
  const [checkedSubjects, setCheckedSubjects] = useState<string[]>([]);

  useEffect(() => {
    if (defaultChecked && subjects) {
      setCheckedSubjects((_prev) => [
        ...subjects.map((subject) => subject.toLowerCase()),
      ]);
    }
  }, [defaultChecked, subjects]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checkedValue = e.target.value.toLowerCase();

    const index = checkedSubjects.findIndex(
      (subject: string) => subject === checkedValue,
    );
    if (index !== -1) {
      setCheckedSubjects((_checkedSubjects: string[]) =>
        _checkedSubjects.filter((subject) => subject !== checkedValue),
      );
    } else {
      setCheckedSubjects((_checkedSubjects: string[]) => [
        ..._checkedSubjects,
        checkedValue,
      ]);
    }
  };

  return [checkedSubjects, handleChange];
};
